import colors from "./colors.json";

const theme = colors.default;

export default theme;
